import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

/**
 * Linear progress for guided tour steps.
 *
 * @param {{ activeStep: number, stepCount: number, stepTitle?: string, personaLabel?: string }} props
 */
const TourProgressBar = ({
    activeStep = 0,
    stepCount = 1,
    stepTitle = '',
    personaLabel = '',
}) => {
    const progress = stepCount > 0 ? ((activeStep + 1) / stepCount) * 100 : 0;

    return (
        <Box sx={{ width: '100%' }} aria-live="polite">
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                Step {activeStep + 1} of {stepCount}
                {stepTitle ? ` · ${stepTitle}` : ''}
                {personaLabel ? ` · ${personaLabel}` : ''}
            </Typography>
            <LinearProgress
                variant="determinate"
                value={progress}
                aria-label={`Tour progress step ${activeStep + 1} of ${stepCount}`}
                sx={{ height: 6, borderRadius: 1 }}
            />
        </Box>
    );
};

export default TourProgressBar;
